<div class="markdown" [class.inline-markdown]="inline">
  <span [innerHTML]="displayText | markdown | async"></span
  ><span 
    *ngIf="wordCount > maxLength" 
    (click)="toggleExpanded()"
    class="show-more-less"
  >{{ expanded ? ' show less' : ' show more' }}</span>
</div>
